import { render, staticRenderFns } from "./error-info-drawer-faq.vue?vue&type=template&id=f70b0282&scoped=true&"
import script from "./error-info-drawer-faq.vue?vue&type=script&lang=js&"
export * from "./error-info-drawer-faq.vue?vue&type=script&lang=js&"
import style0 from "./error-info-drawer-faq.vue?vue&type=style&index=0&id=f70b0282&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70b0282",
  null
  
)

export default component.exports